
'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./hydrate.cjs.production.min.js')
} else {
  module.exports = require('./hydrate.cjs.development.js')
}
